import { ArrowUpRight, ChevronDown } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './BriefParts.module.scss';
import SmallCaps from './SmallCaps';

export const BriefItem = ({ children, actions, className }) => (
  <div className={[styles.item, className].filter(Boolean).join(' ')}>
    <div className={styles.itemBody}>{children}</div>
    {actions && <div className={styles.itemActions}>{actions}</div>}
  </div>
);

export const BriefField = ({ label, children, className }) => (
  <div className={[styles.field, className].filter(Boolean).join(' ')}>
    <SmallCaps>{label}</SmallCaps>
    <div className={styles.fieldValue}>{children}</div>
  </div>
);

export const ItemAction = ({ label, describes, onClick, disabled = false, hasPopup = true }) => (
  <button
    type="button"
    className={styles.lineButton}
    disabled={disabled}
    aria-haspopup={hasPopup ? 'dialog' : undefined}
    aria-label={describes ? `${label}, ${describes}` : label}
    onClick={onClick}
  >
    {label}
    <ArrowUpRight size={14} aria-hidden="true" />
  </button>
);

export const ItemLink = ({ label, describes, href }) => (
  <a
    className={styles.lineButton}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`${label}${describes ? `, ${describes}` : ''} (opens in a new tab)`}
  >
    {label}
    <ArrowUpRight size={14} aria-hidden="true" />
  </a>
);

export const ItemAbsent = ({ children }) => <span className={styles.absent}>{children}</span>;

export const RowNote = ({ children, className }) => (
  <p className={[styles.note, className].filter(Boolean).join(' ')}>{children}</p>
);

export const RowToggle = ({ expanded, onToggle, children }) => (
  <button type="button" className={styles.toggle} aria-expanded={expanded} onClick={onToggle}>
    {children}
    <ChevronDown
      size={14}
      aria-hidden="true"
      className={`${styles.toggleChevron} ${expanded ? styles.toggleChevronOpen : ''}`}
    />
  </button>
);

BriefItem.propTypes = {
  children: PropTypes.node,
  actions: PropTypes.node,
  className: PropTypes.string,
};
BriefField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};
ItemAction.propTypes = {
  label: PropTypes.string.isRequired,
  describes: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  hasPopup: PropTypes.bool,
};
ItemLink.propTypes = {
  label: PropTypes.string.isRequired,
  describes: PropTypes.string,
  href: PropTypes.string.isRequired,
};
ItemAbsent.propTypes = { children: PropTypes.node };
RowNote.propTypes = { children: PropTypes.node, className: PropTypes.string };
RowToggle.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node,
};
